import { Component, OnInit, ViewChild,  } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as firebase from "firebase";
import { NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../_services/user.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {

  database = firebase.database();
  userId = this.userService.getUid();
  sub: Subscription;
  isMobile= false;
  @ViewChild("t") tabs: NgbTabset;
  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
  ) { 
    this.isMobile = window.matchMedia('(max-width: 768px)').matches;
  }

  ngOnInit() {
    this.sub = this.route.queryParams.subscribe(queryParams => {
      const type = queryParams['type'];
      if(type)
      this.select(type);
    })
  }
  select(item) {
    this.tabs.select(item);
  }
  ngOnDestroy() {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.sub.unsubscribe();
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/pages/search/search.component.ts